<div class="progress-bar-wrapper standard-container pb-4" #container>
  @if (formStepperRef?.swiperInstance(); as swiper) {
    <div class="z-3 sticky top-0 bg-white">
      <dojo-swiper-progress class="progress-bar" [swiperInstance]="swiper" />
    </div>
  }
</div>
<ion-content scrollEvents="true" (ionScroll)="onScroll($event)">
  <div class="standard-container h-full" [@appearDisappear]>
    <div>
      <dojo-sensei
        class="course-sensei block max-w-[400px]"
        [activeStoryCharacter]="state.senseiCharacter"
        [activeSpeechBubble]="state.speechBubble"
      />
    </div>
    <dojo-swiper-stepper
      [form]="form"
      [submitFn]="formCompleteFn"
      [swiperOptions]="swiperStepperOptions"
      #formStepperRef
      class="block pb-4"
    >
      <swiper-slide [controlName]="'courseCompositeId'" [updateSwiperHeightOnEmission]="availableCoursesOptions$">
        <div class="small-container">
          <dojo-selection-cards
            class="course-options"
            [formCtrl]="form.controls.courseCompositeId"
            [options]="state.availableCoursesOptions"
            [figureIconSize]="48"
          />
        </div>
      </swiper-slide>
      <swiper-slide [controlName]="'examDateId'">
        @if (state.examDateOptions.length > 0) {
          <div class="tiny-container">
            <dojo-selection-list
              [formCtrl]="form.controls.examDateId"
              [options]="state.examDateOptions"
              [hideIndicator]="true"
            />
          </div>
        } @else {
          <div class="flex items-center justify-center p-4 text-center text-gray-500">
            <dojo-empty-state [header]="'settings.course.no_exam_dates_available' | transloco" />
          </div>
        }
      </swiper-slide>
    </dojo-swiper-stepper>
  </div>
</ion-content>

<dojo-footer-panel (leftButtonClicked)="closeForm()" [leftButtonLabel]="canQuit ? 'quit' : undefined">
  <div class="right">
    <dojo-button class="w-full md:min-w-[178px]" swiperStepperNext [swiperStepper]="formStepperRef">
      {{ 'continue' | transloco }}
    </dojo-button>
  </div>
</dojo-footer-panel>
